import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';

import terminalIcon from '../../Assets/images/card.png';
import { useI18n } from '~Hooks';
import { POSPayment } from '~reducers';
import Circle from './Components/Circle';

const Wrapper = styled.div<{
  show: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 12;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 264px 64px 165px 64px;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};

  @media (orientation: landscape) {
    padding: 148px 67px 92px 67px;
    justify-content: center;
  }
`;

const Title = styled.h2`
  margin: 0 0 40px 0;
  color: rgb(19, 19, 22);
  font-family: Eina01-SemiBold;
  font-size: 80px;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 72px;
  text-align: center;

  @media (orientation: landscape) {
    font-size: 68px;
    line-height: 61px;
  }
`;

const Description = styled.p`
  margin: 0;
  color: rgb(19, 19, 22);
  font-family: Eina01-Regular;
  font-size: 48px;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 56px;
  text-align: center;

  @media (orientation: landscape) {
    font-size: 40px;
    line-height: 47px;
  }
`;

const Image = styled.img`
  width: 549px;
  margin: 262px 0 0 0;

  @media (orientation: landscape) {
    width: 308px;
    margin: 130px 0 0 0;
  }
`;

const Center = styled.div`
  flex: 1;
`;

const ProgressTitle = styled.p`
  margin: 0;
  color: rgb(33, 33, 36);
  font-family: Eina01-Regular;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 20px;
  text-align: center;
  margin-top: 39px;
`;

type Props = {
  onFailPayment: () => void;
  payment?: POSPayment;
  setShowOrderNumber: React.Dispatch<React.SetStateAction<boolean>>;
};

const Checkout: React.FunctionComponent<Props> = ({
  onFailPayment,
  payment,
  setShowOrderNumber,
}: Props) => {
  const { i18n } = useI18n();
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState('PENDING');

  useEffect(() => {
    if (!payment) {
      return;
    }

    setShow(true);

    /*
     * Handle payment status updates
     */
    switch (payment.status) {
      case 'FAILED':
        onFailPayment();
        onHide('FAILED');
        break;
      case 'COMPLETED':
        onHide('COMPLETED');
        break;
      default:
        setStatus('PENDING');
        break;
    }
  }, [payment]);

  const onHide = (text: string) => {
    setTimeout(() => {
      setStatus(text);
      setTimeout(() => {
        setShow(false);
      }, 2000);

      if (text === 'FAILED') {
        return;
      }
      setShowOrderNumber(true);
    }, 1000);
  };

  return (
    <Wrapper show={show}>
      <Title>{i18n('SSK.Order.InsertYourCard')}</Title>
      <Description>{i18n('SSK.Order.FollowTheInstructionsInThePaymentTerminal')}</Description>
      <Center>
        <Image src={terminalIcon} />
      </Center>
      {show && <Circle status={payment?.status} />}
      <ProgressTitle>{i18n(`SSK.Checkout.Status.${status}`)}</ProgressTitle>
    </Wrapper>
  );
};

export default Checkout;
